function truncateText(text, maxLength) {
    if (!text || text?.length <= maxLength) {
        return text;
    }
    return text.substring(0, maxLength) + "...";
}

export default truncateText;
